const objectDE = {
    order: 'Bestellung | Bestellungen',
    article: 'Artikelpositionen',
    promotion: 'Aktion | Aktionen',
    location: 'Location',
    cart: 'Warenkorb',
    list: 'Liste | Listen',
    filter: 'Filter',
    message: 'Nachricht | Nachrichten',
    catalog: 'Katalog',
    notification: 'Benachrichtigung | Benachrichtigungen',
    notificationOption: `@:object.notification{'soptionen'}`,
    setting: 'Einstellungen',
    intro: 'Apptour',
    home: 'Home',
    dark: 'Dunkel',
    light: 'Hell',
    zip: 'PLZ',
    city: 'Ort',
    street: 'Straße',
    lastname: 'Name',
    firstname: 'Vorname',
    address: 'Addresse',
    zipCity: '@object:zip, @object:city',
    profile: 'Profil',
    pointSystem: 'Punktesystem',
    amount: 'Menge',
    price: 'Einzelpreis',
    total: 'Gesamtpreis',
    notAvailable: 'Preisinformation nicht verfügbar',
    sort: 'Sortieren',
    alphabetic: 'Alphabetisch',
    filterCategory: `@:object.filter{'kategorie'}`,
    priceRange: 'Preisrange',
    team: 'Team',
    deliverer: 'Lieferant | Lieferanten',
    display: 'Darstellungsoptionen',
    statistic: 'Statistiken',
    imprint: 'Impressum',
    law: 'Rechtliches',
    support: 'Octopus Order Support',
    filterOption: {
        spirits: 'Spirituosen',
        nonAlcoholic: 'Alkoholfreie Getränke',
        beer: 'Bier',
        gastro: 'Gastro Bedarf',
        wine: 'Wein',
        food: 'Food',
        nonFood: 'Non Food',
        other: 'Sonstiges'
    },
    suggestion: 'Produkt{hyphen}vorschlag | Produkt{hyphen}vorschläge',
    news: 'News',
    days: "Tage | Tag",
    hours: "Stunden | Stunde",
    minutes: "Minuten | Minute",
    validFor: "Gültig für {value}",
    validUntil: "Gültig bis",
    expired: "Abgelaufen",
    totalPosition: 'Summe Position',
    totalOrder: 'Gesamt Bestellwert'
}

export default objectDE
